module.exports = __webpack_public_path__ + "img/food2.eef096cf.png";